import { httpCatalog } from "../helper/http-common";

class SearchColorStoneService {
    SearchColorStones(inputData, type) {
       if (type === "LAB") {
         return httpCatalog.post(
           "/SearchColorStone/SearchLabGrownColorStonesList",
           inputData
         );
       } else {
         return httpCatalog.post("/SearchColorStone/SearchColorStones", inputData);
       }
     }
}

export default new SearchColorStoneService();